import { Constants } from '../constants';

export const getBannerImageUrl = (fileName: string) => `${Constants.bannerCdnUrl}/${fileName}` as const;
